import React, {useEffect, useState, useLayoutEffect , useRef} from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import LogoWholehearted from "../../../assets/logo-wholehearted-global-transparent.png";
import LocalStorageDataStorer from "../../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../../dataAccessLayer/localStorage/LocalStorageKey";
import AppConfigurationSection from "../../components/AppConfigurationSection";
import HtmlElementFormatter from "../../../utils/formatters/HtmlElementFormatter";
import QuestionnaireSection from "../../components/QuestionnaireSection";
import MyJourneySection from "../../components/MyJourneySection";
import AccessControlInspector from "../../../serviceLayer/authorization/AccessControlInspector";
import SessionService from "../../../serviceLayer/session/SessionService";
import SessionConfiguration from "../../../utils/configuration/SessionConfiguration";
import SessionManager from "../../../businessLayer/managers/SessionManager";


export default function Main(props){
    // const navigate = useNavigate();
    // const [session, setSession] = useState(null);
    // const timerRef = useRef(null);

    const [username, setUsername] = useState("");
    const [displayQuestionnaireSectionOnClick, setDisplayQuestionnaireSectionOnClick] = useState(false);
    const [displayMyJourneySectionOnClick, setDisplayMyJourneySectionOnClick] = useState(false);
    
    const [canDisplayPage, setCanDisplayPage] = useState(false);
    const [canViewJourney, setCanViewJourney] = useState(false); 
    const [canViewQuestionnaireStatus, setCanViewQuestionnaireStatus] = useState(false);
    const cardRef = useRef(null);

    useEffect(()=>{
        processUserPermissions(props.resource.name, props.resource.actions);
        processSetUsername();       
        removeItemsFromLocalStorage();
        
    },[]);

    useLayoutEffect(() => {
        if (cardRef.current) {
        //console.log("useLaoutEffect. Useful for DOM measurements to prevent visual glitches.");
        // Place your logic here that needs to run only after everything is loaded
        loadQuestionnaireOnClick();
        }
    }, [canViewQuestionnaireStatus]);

    function processUserPermissions(resourceName , actions){
        //console.log("processUserPermissions-resourceName" , resourceName);
        //console.log("processUserPermissions-actions", actions);

        const userCanDisplayPage = AccessControlInspector.userHasPermission(resourceName, actions._display_page);
        const userCanViewJourney = AccessControlInspector.userHasPermission(resourceName, actions._view_my_journey);
        const userCanViewQuestionnaireStatus = AccessControlInspector.userHasPermission(resourceName, actions._view_questionnaire_status);
        
        setCanDisplayPage(userCanDisplayPage);
        setCanViewJourney(userCanViewJourney);
        setCanViewQuestionnaireStatus(userCanViewQuestionnaireStatus);
    }
    function processSetUsername(){
        const jwtUserToken = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.jwtUserToken);
        if(jwtUserToken){
            const decodedToken = jwtDecode(jwtUserToken);
            //console.log("ResourceProtector-decodedToken", decodedToken);
            const username = decodedToken.user.username;       
            setUsername(username);
        }        
    }

    function loadMyJourneyOnClick(){
        HtmlElementFormatter.setButtonOn("customer-my-journey1","btn-element-active");
        HtmlElementFormatter.setButtonOff("customer-questionnaire1","btn-element-active");
        setDisplayMyJourneySectionOnClick(true);
        setDisplayQuestionnaireSectionOnClick(false);
    }

    function removeItemsFromLocalStorage(){
        LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.QuestionnaireUserResponses);
        LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.currentQuestionnairePage);
        LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.originalRandomizedQuestionnaire);
        LocalStorageDataStorer.removeItemFromLocalStorage(LocalStorageKey.totalQuestionnairePages);
    }

    function loadQuestionnaireOnClick(){
        HtmlElementFormatter.setButtonOn("customer-questionnaire1","btn-element-active");
        HtmlElementFormatter.setButtonOff("customer-my-journey1","btn-element-active");
        setDisplayQuestionnaireSectionOnClick(true);
        setDisplayMyJourneySectionOnClick(false);
    }


    //#region Private Functions BEGIN

    //#region Private Functions END

    return(<div className="app-container font-color-white">
            <div className="header dashboard-header-grid">
                <div className="logo-header-container">                  
                    <img src={LogoWholehearted} alt="logo_wholehearted" className="logo-wholehearted-main"/>
                </div>
                <div className="user-greeting-container">
                    <span className="user-greeting-text">Hello {username}</span> 
                </div>
                <div className="app-configuration-container">
                    <AppConfigurationSection/>
                </div>                
            </div>
            {canDisplayPage && 
            <>
                <div className="nav-bar-container-flex border-darkred">
                    {canViewJourney && <button id="customer-my-journey1" className="btn-element nav-bar-dashboard-btn btn-h45 btn-w115 font-s12" onClick={loadMyJourneyOnClick}>My Journey</button> }
                    {canViewQuestionnaireStatus && <button id="customer-questionnaire1" ref={cardRef} className="btn-element nav-bar-dashboard-btn btn-h45 btn-w115 font-s12" onClick={loadQuestionnaireOnClick}>Questionnaire</button> }
                </div>
             
                <div className="position-rel">
                    {canViewQuestionnaireStatus && displayQuestionnaireSectionOnClick && <QuestionnaireSection />}
                    {canViewJourney && displayMyJourneySectionOnClick && <MyJourneySection />}
                </div>
            </>}
        </div>); 
}